import React from 'react';
import { useTranslation } from 'react-i18next';
import { Flame } from 'lucide-react';
import DealCard from './DealCard';

/**
 * "RendPleX Top Matches" section — surfaces the top 3-5 highest Deal Match
 * candidates above the full result list.
 */
export default function TopMatches({ matches, onAnalyze, onShare }) {
  const { t } = useTranslation();
  if (!matches || matches.length === 0) return null;
  return (
    <div data-testid="scanner-top-matches" className="space-y-4">
      <div className="flex items-center gap-2">
        <Flame className="w-5 h-5 text-orange-500" />
        <h2 className="text-xl font-bold text-[#12355B] dark:text-white">
          {t('dealScanner.topMatchesTitle')}
        </h2>
        <span className="text-xs text-slate-500">
          {t('dealScanner.topMatchesSubtitle')}
        </span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {matches.map((m) => (
          <DealCard
            key={`top-${m.listing_id}`}
            result={m}
            onAnalyze={onAnalyze}
            onShare={onShare}
            top
          />
        ))}
      </div>
    </div>
  );
}
